exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3XnU1DZiD6daIApAOrCdwM,.avKTaWnzwKmuRmIYtzfGM{display:-webkit-box;display:-ms-flexbox;display:flex}._2DR1SRhuUBy8y-7DO1KD5p{color:\"[theme:themePrimary, default:#0078D7]\"}html[dir] ._2DR1SRhuUBy8y-7DO1KD5p{margin-top:2px}html[dir=ltr] ._2DR1SRhuUBy8y-7DO1KD5p{padding-left:0}html[dir=rtl] ._2DR1SRhuUBy8y-7DO1KD5p{padding-right:0}html[dir] ._3gWHODBPIo2YsHT2OTn9fS{margin-top:8px}", ""]);

// exports
exports.locals = {
	"ignoreSubsequentRulesCheckbox": "_3XnU1DZiD6daIApAOrCdwM",
	"runRuleNowCheckbox": "avKTaWnzwKmuRmIYtzfGM",
	"ignoreSubsequentRulesLearnMore": "_2DR1SRhuUBy8y-7DO1KD5p",
	"infoIcon": "_3gWHODBPIo2YsHT2OTn9fS"
};